import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=c6f97d5a&scoped=true"
import script from "./no-content.vue?vue&type=script&lang=js"
export * from "./no-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f97d5a",
  null
  
)

export default component.exports